module.exports = __webpack_public_path__ + "static/img/productIntroduction_02.963b7c50.jpg";